import { Nullable } from 'legacy/lut/classes/models/utils'
import { HtmlField } from 'legacy/lut/components/widgets/public/partner360/fields/HtmlField'
import { FC } from 'react'

import styles from './OneKeyDirectionReadMode.module.scss'

interface IOneKeyDirectionReadModeProps {
  oneKeyDirection: Nullable<string>
}

export const OneKeyDirectionReadMode: FC<IOneKeyDirectionReadModeProps> = ({ oneKeyDirection }) => {
  return (
    <div className={styles.root}>
      <HtmlField
        item={{ oneKeyDirection }}
        htmlClassName={styles.htmlArea}
        value={oneKeyDirection ? oneKeyDirection : '<b>-</b>'}
        field="oneKeyDirection"
      />
    </div>
  )
}
